 const aminitiesCategories = [
  { id:1, name:"Lobby & Common"    },
  { id:2, name:"Sports & Fitness"  },
  { id:3, name:"Kids & Family"     },
  { id:4, name:"Security & Safety" },
  { id:5, name:"Green & Outdoor"   },
  { id:6, name:"Technology"        },
  { id:7, name:"Convenience"       },
];


export default aminitiesCategories;